(function () {
    angular.module('app')
        .directive('stickyManager', stickyManager);

    stickyManager.$inject = [];
    function stickyManager() {
        var directive = {
            restrict: 'A',
            controller: controller
        };
        return directive;
        function controller() {
            var ctrl = this;
            ctrl.$onInit = function () {
                ctrl.stickies = [];
            };

            ctrl.stickPoint = 0;
            ctrl.getStickPoint = function (id) {
                var offset = 0;
                for (var i = 0; i < ctrl.stickies.length; i++) {
                    var target = ctrl.stickies[i];
                    if (target.id === id) {
                        return offset;
                    }
                    else if (!target.controller.released && target.controller.sticking) {
                        offset += target.element.height();
                    }
                }
                return offset;
            };

            ctrl.registerSticky = function (id, element, controller) {
                var registration = {
                    id: id,
                    element: element,
                    controller: controller
                };
                console.log(controller.prioritize);
                if (controller.prioritize) {
                    ctrl.stickies.unshift(registration);
                }
                else {
                    ctrl.stickies.push(registration);
                }
                console.log(ctrl.stickies);
            };
        }
    }
})();